// Created by hejikun on 2017/10/25 0025.
let state = {
  ask_hasMore: true, // 加载更多状态
  ask_deps: [], // 部门列表
  ask_doc_group_recommend: [], // 医师团队推荐列表
  ask_active_group: [], // 活跃医师
  ask_myfollow_group: [], // 我关注的医师列表
  ask_myfollow_question: [], // 我围观的问题列表
  ask_question_list: [], // 公开问题列表
  ask_comment_list: [], // 医师评价列表
  ask_comment_count: 0, // 评论总数
  ask_doclist_for_dep: [], // 某个科室下面的医师列表
  ask_doctor_detail: {}, // 医师详情
  ask_question_detail: {}, // 问题详情
  ask_comment_detail: {}, // 评论详情
  ask_upload_imgs: [], // 上传图片
  ask_form_data: {}, // 问诊订单数据
  ask_tel_schedules: [], // 电话问诊排班列表
  ask_tel_sch: {}, // 选择的电话问诊排班信息
  ask_tel_form: {
    price: '',
    phone: '',
    time: ''
  }, // 电话问诊表单信息
  ask_order_info: {} // 问诊支付信息
}

const actions = {
  // 获取部门列表
  getDeps({ commit }) {
    let channel = sessionStorage.getItem('fromCsfw')
    window.axiosBaseApi
      .get(`/ask2/sdepart?channel=${channel === 'kunhua' ? 'kunhua' : channel === 'yanan' ? 'yanan' : ''}`)
      .then((res) => {
        if (res && res.data && res.data.code === 1) {
          commit('set_ask_deps', res.data.data)
          return Promise.resolve(res.data.data)
        } else {
          commit('set_ask_deps', [])
          return Promise.resolve([])
        }
      })
      .catch((e) => {
        return Promise.reject(e)
      })
  }
}

const getters = {
  // 部门列表格式化
  ask_deps(state) {
    return Array.apply(null, { length: state.ask_deps.length }).map((_, index) => {
      return {
        key: state.ask_deps[index].id,
        title: state.ask_deps[index].depart_name,
        url: state.ask_deps[index].logo,
        data: state.ask_deps[index],
        path: '/ask_doctor_group_list?id=' + state.ask_deps[index].id
      }
    })
  },
  // 包括"所有"选项的部门列表格式化
  ask_deps_with_all(state, getters) {
    let arr = JSON.parse(JSON.stringify(getters.ask_deps))
    arr.unshift({
      key: '',
      title: '推荐',
      data: {
        id: ''
      }
    })
    return arr
  },
  // 活跃医师格式化
  ask_doc_active_group(state) {
    return Array.apply(null, { length: state.ask_active_group.length }).map((_, index) => {
      let avatar = state.ask_active_group[index].avatar
      return {
        key: state.ask_active_group[index].id,
        title: state.ask_active_group[index].name,
        subTitle: state.ask_active_group[index].title,
        desc: state.ask_active_group[index].depart_name,
        url: avatar && avatar !== '' ? avatar : '/static/img/ask/doctoricon.png',
        data: state.ask_active_group[index]
      }
    })
  },
  // 明星医师格式化
  ask_doc_group(state) {
    return Array.apply(null, { length: state.ask_doc_group_recommend.length }).map((_, index) => {
      let avatar = state.ask_doc_group_recommend[index].avatar
      return {
        key: state.ask_doc_group_recommend[index].id,
        title: state.ask_doc_group_recommend[index].name,
        subTitle: state.ask_doc_group_recommend[index].title,
        desc: state.ask_doc_group_recommend[index].depart_name,
        url: avatar && avatar !== '' ? avatar : '/static/img/ask/doctoricon.png',
        data: state.ask_doc_group_recommend[index]
      }
    })
  },
  // 我关注的医师格式化
  ask_my_follow_group(state) {
    return Array.apply(null, { length: state.ask_myfollow_group.length }).map((_, index) => {
      return {
        key: state.ask_myfollow_group[index].id,
        title: state.ask_myfollow_group[index].name,
        subTitle: state.ask_myfollow_group[index].tag,
        url: state.ask_myfollow_group[index].avatar,
        data: state.ask_myfollow_group[index]
      }
    })
  },
  // 我的问题列表
  ask_my_question_list(state) {
    return state.ask_question_list.filter((item) => {
      return item.status > 0
    })
  },
  // 获取用户追问次数
  ask_user_log_count(state) {
    let count = 0
    if (state.ask_question_detail.questions_log && state.ask_question_detail.questions_log.length > 0) {
      state.ask_question_detail.questions_log.forEach((item) => {
        // 只是图片的时候不计次数 content 为空 voice 为空
        if (item.log_type === 2 && (item.content !== '' || item.voice !== '')) {
          count++
        }
      })
    }
    return count
  },
  // 计算问诊服务类型列表
  ask_servers_list(state) {
    let services = []
    let hasTuwen = false
    let hasPhone = false
    if (state.ask_doctor_detail && state.ask_doctor_detail.server) {
      state.ask_doctor_detail.server.forEach((item) => {
        if (item.ser_id === 1) {
          hasTuwen = true
          item.src_enable = '/static/img/ask/picture.png'
          item.src_disable = '/static/img/ask/picture.png'
        } else if (item.ser_id === 2 || item.ser_id === 9 || item.ser_id === 8) {
          hasPhone = true
          item.src_enable = '/static/img/ask/tel.png'
          item.src_disable = '/static/img/ask/tel.png'
          item.ser_info = '医生约定时间与您电话沟通'
        }
        services.push(item)
      })
    }
    if (!hasTuwen) {
      services.push({
        src_enable: '/static/img/ask/picture.png',
        src_disable: '/static/img/ask/picture.png',
        ser_name: '图文问诊',
        ser_info: '三次提问机会，24小时未回复自动退款',
        status: 0
      })
    }
    if (!hasPhone) {
      services.push({
        src_enable: '/static/img/ask/tel.png',
        src_disable: '/static/img/ask/tel.png',
        ser_name: '电话问诊',
        ser_info: '医生约定时间与您电话沟通',
        status: 0
      })
    }
    return services
  }
}

const mutations = {
  // 设置部门列表
  set_ask_deps(state, arg) {
    state.ask_deps = arg
  },
  // 设置上传图片
  set_ask_upload_imgs(state, arg) {
    state.ask_upload_imgs = arg
  },
  set_ask_form_data(state, arg) {
    state.ask_form_data = arg
  },
  set_ask_order_info(state, arg) {
    state.ask_order_info = arg
  },
  set_ask_tel_form(state, args) {
    switch (args.type) {
      case 'phone':
        state.ask_tel_form.phone = args.data
        break
      case 'time':
        state.ask_tel_form.time = args.data
        break
      case 'price':
        state.ask_tel_form.price = args.data
        break
      default:
        break
    }
  }
}

export default {
  state,
  mutations,
  actions,
  getters
}
